/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [user-link.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 29.08.18 18:26
 */

import moment from 'moment';

import React from 'react';
import {PLACEHOLDER} from "../../static";
import {getUserAvatar} from "../../actions/environment";
import {useLanguage} from "../configuration/configuration";
import {HtmlTooltipLink} from "../navigation/buttons/nav-buttons";
import {STATE_SHARED} from "../../actions/spaces";

const UserLink = ({allowComments, post: {user, created, state, from, fromSpace}}) => {
    const Lang = useLanguage();

    const renderAvatar = (user, avatar) => {
        const image = avatar ? avatar : getUserAvatar(user);
        return <div className="avatar-tooltip" id="avatar-tooltip-id">
            <span title={user.fullname}><img src={image}/></span>
        </div>
    }

    const renderUser = (user, text) => {
        const avatar = getUserAvatar(user);
        return <>
            <div className='user-link'>
                <HtmlTooltipLink to={`/${user.username}/home`}
                                 html={renderAvatar(user, avatar)}
                                 htmlParams={{theme: 'avatar', placeholderId: 'avatar-tooltip-id'}}>
                    <img className="thumb" src={PLACEHOLDER} data-src={avatar}/>
                    {user.fullname}
                </HtmlTooltipLink>
                {allowComments &&
                    <span
                        className="comment-created">{text} {moment(created).fromNow()}</span>}

            </div>
        </>
    }

    const isFrom = state === STATE_SHARED && from && from.username !== user.username;
    return <div className='user-link'>
        {!isFrom && renderUser(user, Lang.userLink.posted)}
        {isFrom && renderUser(from, Lang.userLink.shared)}
    </div>
}

export default UserLink;